import Ajax from "Pub/js/ajax";
import Notice from "Components/Notice";
import { langCheck, GetQuery, updateDimenMap } from "Pub/js/utils";
import platform from "Pub/js/platform";
const { pageTo } = platform;
function jumpPCURL(params) {
    let list = params.split('|').map(el => {
        let url = el.split('PCURL=')[1];
        let searchUrl = url.substring(url.indexOf('?'));
        const searchParams = searchUrl.length && GetQuery(searchUrl);
        const param = searchParams && Object.keys(searchParams).length > 0 ? searchParams : {};
        pageTo.openTo(url, {
            status: "browse",
            scene: "todo",
            c: param.appcode,
            p: param.pagecode,
            jumpEntry: 'messageContent',
            ...param
        });
    });
}
/**
 * 页面跳转
 */
export function OpenLink(item) {
    // 跳审批不需要区分审批流和工作流 merge at 2019-07-30
    if (!item) {
        return;
    }
    let { tabActiveKey } = this.state;
    let _appcode =
        item.funccode == null
            ? ""
            : item.funccode.trim();
    let _pagecode = "";
    let url;
    let { msgsourcetype } = item;
    switch (tabActiveKey) {
        // 跳审批
        case "approve":
            if (item.params != null && item.params.indexOf("pagecode=") >= 0) {
                try {
                    _pagecode = item.params.split("pagecode=")[1].split("&")[0];
                } catch (e) { }
            }
            toApproveDetail({
                pk_message: item.pk_message,
                billtype: item.billtype,
                billid: item.billid,
                appcode: (item.funccode || "").trim()
            }, {
                c: _appcode,
                p: _pagecode,
                msgType: item.msgsourcetype
            });
            break;
        // 跳业务
        case "todo":
            // let msgsourcetype = item.msgsourcetype;
            if (item.params != null && item.params.indexOf("pagecode=") >= 0) {
                try {
                    _pagecode = item.params.split("pagecode=")[1].split("&")[0];
                } catch (e) { }
            }
            // 新增加规则，消息数据中有params字段包含PCURL字段时，直接跳转该字段的url地址
            if (item.params != null && item.params.indexOf('PCURL=') >= 0) {
                jumpPCURL(item.params);
                return;
            }
            url = "/nccloud/riart/message/getTodoUrl.do";
            // if (tabActiveKey == "noticeitem") {
            //     url = "/nccloud/riart/message/getNoticeUrl.do";
            // }
            Ajax({
                url: url,
                async: false,
                data: {
                    pk_message: item.pk_message,
                    billid: item.billid,
                    billtype: item.billtype,
                    appcode:
                        item.funccode == null
                            ? ""
                            : item.funccode.trim(),
                    params: item.params
                },
                info: {
                    name: langCheck("0000PUB-000113") /* 国际化处理： 消息*/,
                    action: langCheck(
                        "0000PUB-000315"
                    ) /* 国际化处理： 查询消息跳转url*/
                },
                method: "POST",
                success: res => {
                    if (res.data && res.data.data) {
                        let url = res.data.data;
                        if (url == "no permission") {
                            Notice({
                                status: "warning",
                                msg: langCheck("0000PUB-000274")
                            }); /* 国际化处理： 没有审批应用权限或配置错误，请联系管理员。*/
                            return;
                        }
                        let finalUrl = url;
                        if (url.indexOf("?") == -1) {
                            finalUrl = url + "?scene=" + msgsourcetype;
                        } else if (url.indexOf("#") >= 0) {
                            finalUrl =
                                url +
                                (url.split("#")[1].length > 0 ? "&" : "") +
                                "scene=" +
                                msgsourcetype;
                        } else {
                            finalUrl = url + "#scene=" + msgsourcetype;
                        }
                        if (res.data) {
                            pageTo.openTo(`${finalUrl}&pk_message=${item.pk_message}`, {
                                appcode: _appcode,
                                pagecode: _pagecode,
                                c: _appcode,
                                p: _pagecode,
                                id: item.billid,
                                jumpEntry: 'messageContent',
                            });
                        }
                    } else {
                        // 无详情的通知 跳列表
                        pageTo.openTo(
                            "/nccloud/resources/uap/msgcenter/message/main/index.html?msgType=todo",
                            {
                                appcode: "10160502",
                            }
                        );
                    }
                }
            });
            break;
        case 'notice':
            jumpToNotic.call(this, item);
            break;
        default:
            break;
    }
}

/**
 * 跳转Notice
 * @param {Object} item Notice数据
 */
function jumpToNotic(item) {
    let { funccode, billtype, detail, msgsourcetype, funcid } = item;
    let p;
    if (msgsourcetype === 'addApproveFinished' && funcid) {
        toApproveDetail({
            pk_group: item.pk_group,
            pk_message: funcid,
            billtype,
            billid: item.billid,
            appcode: funccode
        }, {
            msgType: 'approve'
        });
        return;
    } else if (funccode && !billtype) {
        p = getNoticeUrlInfoByFunccode.call(this, item);
    } else if (detail) {
        p = getNoticeUrlInfoByDetail.call(this, item);
    }
    p && p.then((data) => {
        let { finalUrl, info } = data;
        if (finalUrl) {
            pageTo.openTo(finalUrl, info);
        }
        return;
    });
}

/**
 * 统一的url查询接口
 * @param {Object} data 提价数据
 */
function queryOpenBillUrl(data) {
    return new Promise((resolve) => {
        let url = '/nccloud/workflow/flowmanagecentre/openBillUrlQueryAction.do';
        Ajax({
            url,
            method: 'POST',
            async: false,
            data,
            success: ({ data }) => {
                resolve(data.data);
            }
        });
    });
}

/**
 * 通过funccode字段，获取Notcie Url
 * @param {Object} item Notice数据
 * @returns Promise
 */
function getNoticeUrlInfoByFunccode(item) {
    let { funccode, params, billid } = item;
    return new Promise((resolve) => {
        queryOpenBillUrl.call(this, { funccode, billid }).then((data) => {
            let { appcode, pageurl, pagecode } = data;
            let finalUrl = `${pageurl}?appcode=${appcode}&pagecode=${pagecode}`;
            if (params) {
                finalUrl += `&${params}`;
            }
            let ret = {
                finalUrl,
                info: {
                    status: 'browse',
                    id: billid,
                    appcode,
                    pagecode,
                    c: appcode,
                    p: pagecode
                }
            };
            resolve(ret);
        });
    });
}

/**
 * 通过detail字段，获取Notice Url
 * @param {Object} item Notice数据
 * @returns Promise
 */
function getNoticeUrlInfoByDetail(item) {
    return new Promise((resolve) => {
        let { detail, billid, msgsourcetype, funccode } = item;
        let pcurl = getParamValue(detail, 'PCURL', '@');
        let appcode, pagecode, finalUrl;
        let ret;
        if (pcurl != null) {
            // 如果从detail字段里找到了指定的该消息应该跳转到哪个URL，直接跳过去
            appcode = getParamValue(pcurl, 'appcode', '&');
            pagecode = getParamValue(pcurl, 'pagecode', '&');
            finalUrl = handleURL(pcurl, 'notice', billid);
            ret = {
                finalUrl,
                info: {
                    id: billid,
                    status: 'browse',
                    appcode,
                    pagecode,
                    c: appcode,
                    p: pagecode
                }
            };
            resolve(ret);
        } else {
            // 否则需要通过detail字段向后台查询
            queryOpenBillUrl.call(this, { detail, funccode, billid }).then((data) => {
                let { appcode, pageurl, pagecode } = data;
                finalUrl = handleURL(pageurl, msgsourcetype, billid);
                ret = {
                    finalUrl,
                    info: {
                        id: billid,
                        status: 'browse',
                        appcode,
                        pagecode,
                        c: appcode,
                        p: pagecode
                    }
                };
                resolve(ret);
            });
        }

    });
}
function toApproveDetail(ajaxParams, funcParams = {}) {
    Ajax({
        url: "/nccloud/riart/message/getApproveUrl.do",
        data: ajaxParams,
        // {
        //     pk_group
        //     pk_message,
        //     billtype,
        //     billid,
        //     appcode
        // }
        info: {
            name: langCheck("0000PUB-000113") /* 国际化处理： 消息*/,
            action: langCheck("0000PUB-000315") /* 国际化处理： 查询消息跳转url*/
        },
        method: "POST",
        success: res => {
            if (res.data && res.data.data.crossGroup === 'crossGroup') {
                Notice({ status: "error", msg: langCheck("0000PUB-000675") }); /* 国际化处理： 该消息不支持查看卡片详情，请切换集团。*/
                return;
            }
            let url = (res.data && res.data.data.pageurl) || "no permission";
            if (url == "no permission") {
                Notice({
                    status: "error",
                    msg: langCheck("0000PUB-000274")
                }); /* 国际化处理： 没有审批应用权限或配置错误，请联系管理员。*/
                return;
            }
            if (url == "message not found") {
                Notice({
                    status: "error",
                    msg: langCheck("0000PUB-000275")
                }); /* 国际化处理： 没有找到该消息*/
                return;
            }

            updateDimenMap(res.data.data.appcode, res.data.data.assignReg);
            pageTo.openTo(
                "/nccloud/resources/uap/msgcenter/message/approveDetail/index.html?pk_message=" +
                ajaxParams.pk_message +
                "&pageMsgType=" +
                funcParams.msgType,
                {
                    appcode: "10160501",
                    pagecode: "10160501APPROVE",
                    c: res.data.data.appcode || funcParams.c,
                    p: res.data.data.pagecode || funcParams.p,
                    n: res.data.data.pagename,
                    checknote: "",
                    jumpEntry: 'messageContent',
                }
            );
        }
    });
}

/**
 * 将制定参数从参数串中取出来
 * @param {String} parameter 总参数
 * @param {String} key 要取出的参数的参数名称
 * @param {String} separator 参数间的分割符
 * @returns {String}
 */
function getParamValue(parameter, key, separator) {
    // 注意有个'='字符
    let keyLength = key.length + 1;
    let startIndex = parameter.indexOf(key);
    if (startIndex === -1) {
        return null;
    }
    let endIndex = parameter.indexOf(separator, startIndex);
    if (endIndex === -1) {
        endIndex = parameter.length;
    }
    return parameter.substring(startIndex + keyLength, endIndex);
}

/**
 * 处理URL
 * @param {String} url URL
 * @param {String} pageMsgType Message Type
 * @param {String} billId Bill id
 * @returns {String}
 */
function handleURL(url, pageMsgType, billId) {
    let finalUrl = '';
    let hasHash = url.split('#')[1].length > 0;
    if (url) {
        finalUrl = `${url}${hasHash ? '?' : ''}status=browse&id=${billId}`;
    } else {
        // 国际化处理： 没有应用权限或配置错误，请检查您是否有此单据权限，或检查单据类型管理页下关联小应用是否配置正确。
        Notice({
            status: "error",
            msg: langCheck("0000PUB-000376")
        });
        return;
    }
    finalUrl += `&scene=${pageMsgType}`;
    return finalUrl;
}

